// DPP-143: public report page ({web}report-link/{token}).

export const REPORT_LINK_STATUS = {
  VALID: 'VALID',
  EXPIRED: 'EXPIRED',
  UNAVAILABLE: 'UNAVAILABLE',
  NOT_FOUND: 'NOT_FOUND'
};

export interface ReportLinkDocument {
  emailDocumentId: string;
  fileName: string;
  contentType: string;
  sizeBytes: number;
}

export interface ReportLinkViewModel {
  status: string;
  subject: string | null;
  // VALID: when the link stops working. EXPIRED: when it stopped.
  expiresDateTime: string | null;
  documents: ReportLinkDocument[];
}
